module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "preface",
    attrs: {
      "id": "adc"
    }
  }, [_c('h1', {
    staticClass: "preface01"
  }, [_vm._v("Other Books by Cathy Guisewite")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("Recent "), _c('em', [_vm._v("Cathy")]), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("®")]), _vm._v(" Collections")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Food"), _c('br'), _vm._v("Love"), _c('br'), _vm._v("Mom"), _c('br'), _vm._v("Work"), _c('br'), _vm._v("Cathy Twentieth Anniversary Collection"), _c('br'), _vm._v("Shoes: Chocolate for the Feet"), _c('br'), _vm._v("I’d Scream Except I Look So Fabulous"), _c('br'), _vm._v("I Am Woman, Hear Me Snore"), _c('br'), _vm._v("Abs of Steel, Buns of Cinnamon"), _c('br'), _vm._v("Understanding the “Why” Chromosome"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_c('strong', [_vm._v("Cathy"), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("®")])])]), _vm._v(" "), _c('strong', [_vm._v("Gift Books")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Confessions to My Mother"), _c('br'), _vm._v("Like Mother, Like Daughter"), _c('br'), _vm._v("Commiserations"), _c('br'), _vm._v("Shop Till You Drop Then Sit Down and Buy Shoes"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("Cookbook")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Girl Food: Cathy’s Cookbook for the Weil-Balanced Woman (with Barbara Albright)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a8b53c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740799426_epub_adc_r1.vue
// module id = 60
// module chunks = 0